/* eslint-disable prefer-destructuring */
import * as React from "react";
import {Helmet} from "react-helmet";
import PropTypes from "prop-types";
import StyleSurveyAPI from "../modules/StyleSurveyAPI";
import {checkProgress} from "../modules/checkProgress";
import {getPageTitle} from "../modules/StyleSurveyHelper";

export default class StyleSurveySignup extends React.PureComponent {

  static propTypes = {
    "customer": PropTypes.object.isRequired,
    "header": PropTypes.element.isRequired,
    "location": PropTypes.object.isRequired,
    "recaptchaSiteKey": PropTypes.string.isRequired
  };

  constructor (props) {
    super(props);
    this.state = {
      "emailValue": "",
      "validateEmailMessage": ""
    };
  }

  componentDidMount = () => {
    checkProgress();
    const emailFromCookie = this.getCookie("RBLeadEmail");

    if (emailFromCookie) {
      this.setState({"emailValue": decodeURIComponent(emailFromCookie)});
    }

    // This loads the reCAPTCHA script when this component is loaded.
    // The reCAPTCHA challenge would not load when the script was loaded
    // from the Rails view.
    const loadScript = (src) => {
      const tag = document.createElement("script");
      tag.async = false;
      tag.src = src;
      const body = document.getElementsByTagName("body")[0];
      body.appendChild(tag);
    };

    loadScript("https://www.google.com/recaptcha/api.js");
  }

  getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return parts.pop().split(";").shift();
    }
    return "";
  }

  handleEmailChange = (event) => {
    this.setState({
      "emailValue": event.currentTarget.value,
      "validateEmailMessage": ""
    });
  }

  handlePasswordChange = event => event.currentTarget.setCustomValidity("");

  handleInvalidPassword = event => event.currentTarget.setCustomValidity(
    "Password must have 8 or more characters including a number, upper case letter, lower case letter," +
    "and special character (e.g. #, !, $, @)"
  );

  submitForm = (event) => {
    event.preventDefault();

    const email = $("#CustomerEmail").val();
    const form = document.getElementById("createCustomer");

    StyleSurveyAPI.validateEmail(email).then((response) => {
      if (response.data === false) {
        this.setState({"validateEmailMessage": "Please enter a valid email address"});
      } else {
        form.submit();
      }
    });
  }

  render () {
    const {"customer": {birthday}, header, location, recaptchaSiteKey} = this.props;
    const {pathname} = location;
    const {emailValue, validateEmailMessage} = this.state;

    return (
      <React.Fragment>
        <Helmet>
          <title>
            {getPageTitle(pathname)}
          </title>
        </Helmet>

        <div className="StyleSurveySignup">
          {header}
          <div className="StyleSurveyAnswers">
            <form
              acceptCharset="UTF-8"
              action="/customers"
              autoComplete="off"
              className="mt0"
              id="createCustomer"
              method="post"
              onSubmit={this.submitForm}
            >
              <div className="validate-email-message">
                {validateEmailMessage}
              </div>
              {birthday &&
              <input
                name="customer[birthday]"
                type="hidden"
                value={birthday}
              />}
              <input
                name="authenticity_token"
                type="hidden"
                value={document.querySelectorAll("meta[name=csrf-token]")[0].getAttribute("content")}
              />
              <input
                aria-label="Email address"
                id="CustomerEmail"
                name="customer[email]"
                onChange={this.handleEmailChange}
                pattern="[^@]+@[^@]+\.[a-zA-Z]{2,6}"
                placeholder="Email"
                required="required"
                type="email"
                value={emailValue}
              />
              <input
                aria-label="Password"
                name="customer[password]"
                onChange={this.handlePasswordChange}
                onInvalid={this.handleInvalidPassword}
                pattern="^.*(?=.{8,})(?=(.*\d|.*[@#$%^!&+=]))(?=.*[a-z|A-Z]).*"
                placeholder="Password"
                required="required"
                type="password"
              />
              <div className="password-requirements">
                Password must have 8 or more characters, including a number or special character (e.g. #, !, $, @)
              </div>

              <div
                align="center"
                className="g-recaptcha"
                data-sitekey={recaptchaSiteKey}
              />

              <input
                className="btn btn-primary centered mt8"
                disabled={validateEmailMessage.length > 0}
                id="SignupSubmitButton"
                name="commit"
                type="submit"
                value="Continue"
              />
            </form>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
